import cn from 'classnames'

import c from './assets/sass/list.module.scss'

export const List = ({
    hasBet,
    cells,
    onCellClick,
    isRevealing,
    gameLost,
}) => {
    return (
        <ul className={cn(c.component, { [c.notActive]: !hasBet || gameLost })}>
            {cells.map(({ id, type, revealed }) => (
                <li
                    key={id}
                    className={cn(
                        c.cell,
                        { [c.flipped]: revealed },
                        revealed && type ? c[type] : null
                    )}
                    onClick={() =>
                        hasBet &&
                        !revealed &&
                        !isRevealing &&
                        !gameLost &&
                        onCellClick(id)
                    }
                >
                    <div className={c.inner}>
                        <div className={c.outside} />
                        <div className={c.backside}>
                            <div className={c.icon} />
                            {type === 'coin' && revealed && (
                                <div className={c.lights} />
                            )}
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    )
}
